import { render, staticRenderFns } from "./EditorControls.vue?vue&type=template&id=766d4043&scoped=true&"
import script from "./EditorControls.vue?vue&type=script&lang=ts&"
export * from "./EditorControls.vue?vue&type=script&lang=ts&"
import style0 from "./EditorControls.vue?vue&type=style&index=0&id=766d4043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d4043",
  null
  
)

export default component.exports